export enum RolloverPropertyRevenueTypeEnum {
  companyRevenue = 'COMPANY_REVENUE',
  propertyRevenue = 'PROPERTY_REVENUE',
}
